import { easeCurves } from "../../motion/eases";
import { css } from 'styled-components';
import { theme, whenFocused, whenHovered } from "../../theme";
/**
 * Eventually we'll provide a proper "Interactive" component
 * which incorporates these styles.
 */

export var focusStyles = css(["box-shadow:0 0 0 0 transparent;", "{box-shadow:inset 0 0 0 1px rgba(255,255,255,0.7);}"], whenFocused);
export var INTERACTIVE_TRANSITION_DURATION = 150;
export var hoverTransition = css(["transition:color 0.15s ", ",background-color 0.15s ", ",box-shadow 0.15s ", ",opacity 0.15s ", ";"], easeCurves.primary, easeCurves.primary, easeCurves.primary, easeCurves.primary);
export var hoverStyles = css(["", ""], function (p) {
  return !p.$sharedHoverEnabled && "\n    background-color: transparent;\n\n    ".concat(whenHovered, " {\n      background-color: ").concat(theme.colors.background.interactive.hover, ";\n    }\n  ");
});